var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card__content" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tipoComprobante === _vm.codigoNotaCredito,
                expression: "tipoComprobante === codigoNotaCredito"
              }
            ],
            staticClass: "col-xs-12 col-md-6"
          },
          [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c(
                    "input-field",
                    {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: "###-###-#########",
                          expression: "'###-###-#########'"
                        }
                      ],
                      attrs: {
                        disabled: _vm.disabled || _vm.modelValue.estado !== "N",
                        readonly:
                          _vm.modelValue.tipo_comprobante_afectado !== "",
                        type: "tel",
                        id: "comprobanteAfectado",
                        placeholder: "N° comprobante"
                      },
                      model: {
                        value: _vm.modelValue.numero_comprobante_afectado,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.modelValue,
                            "numero_comprobante_afectado",
                            $$v
                          )
                        },
                        expression: "modelValue.numero_comprobante_afectado"
                      }
                    },
                    [
                      _c("span", [_vm._v("Comprobante afectado")]),
                      _vm._v(" "),
                      _vm.errores.hasOwnProperty(
                        "cabecera.numero_comprobante_afectado"
                      )
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.errores[
                                      "cabecera.numero_comprobante_afectado"
                                    ][0]
                                  )
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.modelValue.tipo_comprobante_afectado === "" &&
                            _vm.modelValue.estado === "N",
                          expression:
                            "\n                modelValue.tipo_comprobante_afectado === '' &&\n                  modelValue.estado === 'N'\n              "
                        }
                      ],
                      staticClass: "btn-info",
                      attrs: {
                        disabled: _vm.disabled || _vm.modelValue.estado !== "N",
                        type: "button"
                      },
                      on: { click: _vm.consultarComprobantesCompra }
                    },
                    [_c("i", { staticClass: "fa fa-search" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.modelValue.tipo_comprobante_afectado !== "" &&
                            _vm.modelValue.estado === "N",
                          expression:
                            "\n                modelValue.tipo_comprobante_afectado !== '' &&\n                  modelValue.estado === 'N'\n              "
                        }
                      ],
                      staticClass: "btn-danger",
                      attrs: {
                        disabled: _vm.disabled || _vm.modelValue.estado !== "N"
                      },
                      on: { click: _vm.quitarComprobanteAfectado }
                    },
                    [_c("i", { staticClass: "fa fa-ban" })]
                  )
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tipoComprobante === _vm.codigoNotaCredito,
                expression: "tipoComprobante === codigoNotaCredito"
              }
            ],
            staticClass: "col-xs-12 col-md-6"
          },
          [
            _c("div", { staticClass: "form-field" }, [
              _c(
                "div",
                { staticClass: "datepicker-field" },
                [
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      disabled: _vm.modelValue.tipo_comprobante_afectado !== "",
                      id: "fecha_emision_comprobante_afectado",
                      locale: "es",
                      "no-label": "",
                      "only-date": "",
                      "auto-close": "",
                      "button-now-translation": "Ahora",
                      format: "YYYY-MM-DD",
                      formatted: "YYYY-MM-DD",
                      label: "Seleccione una fecha..."
                    },
                    model: {
                      value: _vm.modelValue.fecha_emision_comprobante_afectado,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.modelValue,
                          "fecha_emision_comprobante_afectado",
                          $$v
                        )
                      },
                      expression:
                        "modelValue.fecha_emision_comprobante_afectado"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { attrs: { for: "fecha_emision_comprobante_afectado" } },
                    [_vm._v("Fecha de emisión del comprobante *")]
                  ),
                  _vm._v(" "),
                  _vm.errores.hasOwnProperty(
                    "cabecera.fecha_emision_comprobante_afectado"
                  )
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.errores[
                                  "cabecera.fecha_emision_comprobante_afectado"
                                ][0]
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass: "form-field select2",
              class: {
                "select2--disabled":
                  _vm.disabled ||
                  _vm.modelValue.tipo_comprobante_afectado !== ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "tipoDocumento",
                      placeholder: "Seleccione...",
                      options: _vm.tiposDocumento,
                      label: "descripcion"
                    },
                    on: { input: _vm.inputTipoDocumento },
                    model: {
                      value: _vm.selectedTipoDocumento,
                      callback: function($$v) {
                        _vm.selectedTipoDocumento = $$v
                      },
                      expression: "selectedTipoDocumento"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "tipoDocumento" } }, [
                    _vm._v("Tipo de documento")
                  ]),
                  _vm._v(" "),
                  _vm.errores.hasOwnProperty("cabecera.tipo_documento")
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(
                              _vm._s(_vm.errores["cabecera.tipo_documento"][0])
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c("label", { attrs: { for: "manual" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.tipo,
                    expression: "modelValue.tipo"
                  }
                ],
                attrs: {
                  disabled: _vm.disabled,
                  value: "M",
                  type: "radio",
                  id: "manual"
                },
                domProps: { checked: _vm._q(_vm.modelValue.tipo, "M") },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.modelValue, "tipo", "M")
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Manual")])
            ]),
            _vm._v(" "),
            _c("label", { attrs: { for: "electronico" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.tipo,
                    expression: "modelValue.tipo"
                  }
                ],
                attrs: {
                  disabled: _vm.disabled,
                  value: "E",
                  type: "radio",
                  id: "electronico"
                },
                domProps: { checked: _vm._q(_vm.modelValue.tipo, "E") },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.modelValue, "tipo", "E")
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Electrónico")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c("label", { attrs: { for: "mybillbot" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.modelValue.mybillbot,
                    expression: "modelValue.mybillbot"
                  }
                ],
                attrs: { disabled: "", type: "checkbox", id: "mybillbot" },
                domProps: {
                  checked: Array.isArray(_vm.modelValue.mybillbot)
                    ? _vm._i(_vm.modelValue.mybillbot, null) > -1
                    : _vm.modelValue.mybillbot
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.modelValue.mybillbot,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.modelValue,
                            "mybillbot",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.modelValue,
                            "mybillbot",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.modelValue, "mybillbot", $$c)
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Importado por MyBillBot")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-4" },
          [
            _c(
              "input-field",
              {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "###-###-#########",
                    expression: "'###-###-#########'"
                  }
                ],
                attrs: {
                  disabled: _vm.disabled,
                  id: "numeroDocumento",
                  placeholder: "###-###-#########"
                },
                model: {
                  value: _vm.modelValue.numero_documento,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_documento", $$v)
                  },
                  expression: "modelValue.numero_documento"
                }
              },
              [
                _vm._v("\n          Número de documento\n          "),
                _vm.errores.hasOwnProperty("cabecera.numero_documento")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.errores["cabecera.numero_documento"][0])
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-4" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  disabled: _vm.disabled,
                  placeholder: "Clave de SRI",
                  readonly:
                    _vm.modelValue.tipo === "M" || _vm.modelValue.mybillbot,
                  id: "claveAcceso"
                },
                model: {
                  value: _vm.modelValue.clave_acceso,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "clave_acceso", $$v)
                  },
                  expression: "modelValue.clave_acceso"
                }
              },
              [
                _vm._v("\n          Clave de acceso\n          "),
                _vm.errores.hasOwnProperty("cabecera.clave_acceso")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.errores["cabecera.clave_acceso"][0])
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-4" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  disabled: _vm.disabled,
                  vMoney: "",
                  format: _vm.numero,
                  readonly: _vm.modelValue.mybillbot,
                  placeholder: "##########",
                  id: "numeroAutorizacion"
                },
                model: {
                  value: _vm.modelValue.numero_autorizacion,
                  callback: function($$v) {
                    _vm.$set(_vm.modelValue, "numero_autorizacion", $$v)
                  },
                  expression: "modelValue.numero_autorizacion"
                }
              },
              [
                _vm._v("\n          Número de autorizacion\n          "),
                _vm.errores.hasOwnProperty("cabecera.numero_autorizacion")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.errores["cabecera.numero_autorizacion"][0]
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("date-picker", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: _vm.tipoFechaAutorizacion,
                    format: _vm.formatoFechaAutorizacion,
                    id: "fechaAutorizacion",
                    lang: "es"
                  },
                  model: {
                    value: _vm.modelValue.fecha_autorizacion,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "fecha_autorizacion", $$v)
                    },
                    expression: "modelValue.fecha_autorizacion"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "fechaAutorizacion" } }, [
                  _vm._v("Fecha de autorización")
                ]),
                _vm._v(" "),
                _vm.errores.hasOwnProperty("cabecera.fecha_autorizacion")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.errores["cabecera.fecha_autorizacion"][0]
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "datepicker-field" },
              [
                _c("VueCtkDateTimePicker", {
                  attrs: {
                    disabled: _vm.disabled,
                    id: "fecha_emision",
                    locale: "es",
                    "no-label": "",
                    "only-date": "",
                    "auto-close": "",
                    "button-now-translation": "Ahora",
                    format: "YYYY-MM-DD",
                    formatted: "YYYY-MM-DD",
                    label: "Seleccione una fecha..."
                  },
                  model: {
                    value: _vm.modelValue.fecha_emision,
                    callback: function($$v) {
                      _vm.$set(_vm.modelValue, "fecha_emision", $$v)
                    },
                    expression: "modelValue.fecha_emision"
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "fecha_emision" } }, [
                  _vm._v("Fecha de emisión")
                ]),
                _vm._v(" "),
                _vm.errores.hasOwnProperty("cabecera.fecha_emision")
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(
                            _vm._s(_vm.errores["cabecera.fecha_emision"][0])
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      disabled:
                        _vm.disabled ||
                        _vm.modelValue.tipo_comprobante_afectado !== "",
                      readonly: _vm.modelValue.id_proveedor !== "",
                      vMoney: "",
                      format: _vm.numero,
                      placeholder: "############",
                      id: "numeroIdentificacion"
                    },
                    model: {
                      value: _vm.modelValue.numero_identificacion,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "numero_identificacion", $$v)
                      },
                      expression: "modelValue.numero_identificacion"
                    }
                  },
                  [_vm._v("Identificación")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modelValue.id_proveedor === "",
                        expression: "modelValue.id_proveedor === ''"
                      }
                    ],
                    staticClass: "btn-success",
                    attrs: {
                      disabled:
                        _vm.disabled ||
                        _vm.modelValue.tipo_comprobante_afectado !== "",
                      type: "button"
                    },
                    on: { click: _vm.consultarProveedor }
                  },
                  [_c("i", { staticClass: "fa fa-check" })]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.modelValue.id_proveedor !== "",
                        expression: "modelValue.id_proveedor !== ''"
                      }
                    ],
                    staticClass: "btn-danger",
                    attrs: {
                      disabled:
                        _vm.disabled ||
                        _vm.modelValue.tipo_comprobante_afectado !== "",
                      type: "button"
                    },
                    on: { click: _vm.quitarProveedor }
                  },
                  [_c("i", { staticClass: "fa fa-ban" })]
                ),
                _vm._v(" "),
                _c(
                  "modal",
                  {
                    attrs: {
                      scrollable: "",
                      width: "70%",
                      height: "auto",
                      name: "persona"
                    }
                  },
                  [
                    _c("persona", {
                      attrs: {
                        numeroIdentificacion:
                          _vm.modelValue.numero_identificacion,
                        searchButton: false
                      },
                      on: { saved: _vm.savedPersona }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c("div", { staticClass: "form-field" }, [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: "",
                      id: "nombreProveedor",
                      placeholder: "Proveedor"
                    },
                    model: {
                      value: _vm.modelValue.nombre_proveedor,
                      callback: function($$v) {
                        _vm.$set(_vm.modelValue, "nombre_proveedor", $$v)
                      },
                      expression: "modelValue.nombre_proveedor"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Nombre de proveedor\n              "
                    ),
                    _vm.errores.hasOwnProperty("cabecera.id_proveedor")
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.errores["cabecera.id_proveedor"][0])
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-info",
                    attrs: {
                      disabled:
                        _vm.disabled ||
                        _vm.modelValue.tipo_comprobante_afectado !== "",
                      type: "button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$modal.show("proveedor")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-search" })]
                ),
                _vm._v(" "),
                _c(
                  "modal",
                  {
                    attrs: {
                      width: "55%",
                      height: "auto",
                      name: "proveedor",
                      scrollable: ""
                    }
                  },
                  [
                    _c("lista-personas", {
                      attrs: { tipoFiltro: "P", filterStatus: false },
                      on: { selected: _vm.selectedProveedor }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-xs-12 col-md-4" }, [
          _c(
            "div",
            {
              staticClass: "form-field select2",
              class: {
                "select2--disabled":
                  _vm.disabled ||
                  _vm.modelValue.tipo_comprobante_afectado !== ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      label: "descripcion",
                      options: _vm.monedas,
                      id: "moneda",
                      placeholder: "Seleccione..."
                    },
                    on: { input: _vm.inputMoneda },
                    model: {
                      value: _vm.selectedMoneda,
                      callback: function($$v) {
                        _vm.selectedMoneda = $$v
                      },
                      expression: "selectedMoneda"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "moneda" } }, [_vm._v("Moneda")]),
                  _vm._v(" "),
                  _vm.errores.hasOwnProperty("cabecera.id_moneda")
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores["cabecera.id_moneda"][0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información del comprobante")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22514e01", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22514e01","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/CabeceraCompra.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-22514e01","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/CabeceraCompra.vue
// module chunks = 0